import React, { FunctionComponent } from 'react';

import { toDisplayAddress } from 'scenes/common/helpers/address';
import { Address, SingleFieldStepProps } from 'scenes/common/types';
import { PostalAddressOption } from 'scenes/common/flows/policyDetails/types';
import SingleSegmentedControlStep from 'scenes/common/components/Steps/SingleSegmentedControlStep';
import { SegmentedControlOptions } from 'scenes/common/components/Questions';

const STATE_KEY = 'postalAddressOption';
export const QUESTION =
  "Which postal address would you like to use, if we can't reach you by email?";

const BILLING_ADDRESS_OPTIONS = [
  {
    label: PostalAddressOption.DifferentAddress,
    value: PostalAddressOption.DifferentAddress,
  },
  {
    label: PostalAddressOption.LockedBagGpoAddress,
    value: PostalAddressOption.LockedBagGpoAddress,
  },
];

const PostalAddressStep: FunctionComponent<
  Pick<SingleFieldStepProps<PostalAddressOption>, 'onNext'> & {
    mainAddress: Address;
    postalAddressOption: PostalAddressOption;
    helpText?: string;
    options?: SegmentedControlOptions<string, PostalAddressOption>;
  }
> = ({ mainAddress, postalAddressOption, onNext, helpText, options }) => {
  const postalOptions = options ?? [
    {
      label: toDisplayAddress(mainAddress) || PostalAddressOption.MainAddress,
      value: PostalAddressOption.MainAddress,
    },
    ...BILLING_ADDRESS_OPTIONS,
  ];

  return (
    <SingleSegmentedControlStep
      stack
      onNext={onNext}
      question={QUESTION}
      helpText={helpText}
      stateKey={STATE_KEY}
      options={postalOptions}
      defaultStateValue={postalAddressOption}
      validationRules={{
        validate: {
          oneOf: (value) =>
            postalOptions.some((option) => option.value === value),
        },
      }}
    />
  );
};

export default PostalAddressStep;
